import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Alert } from '@mui/material';
import DialogShell from '../design-system/DialogShell';
import PacienteCamposForm from '../PacienteCamposForm';
import { validarCamposPaciente } from '../../utils/validarPaciente';
import { btnPrimary } from '../../styles/formStyles';

const API = process.env.REACT_APP_API_URL || '';

const FORM_VACIO = {
  nombre: '', apellido: '', dni: '', email: '', telefono: '',
  fecha_nacimiento: '', direccion: '', obra_social: '', numero_afiliado: '',
};

// Mismos campos y mismo selector de Obra Social que el módulo Pacientes (PacienteCamposForm) —
// acá no se crea el paciente todavía: los datos vuelven al turno vía onSuccess y se crean
// junto con el turno en una sola transacción (ver POST /api/turnos, paciente_nuevo).
export default function CrearPacienteDialog({ open, onClose, dniInicial = '', onSuccess }) {
  const [form, setForm] = useState(FORM_VACIO);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [error, setError] = useState('');
  const [errores, setErrores] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/obras-sociales`).then(r => setObrasSociales(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (open) setForm(f => ({ ...FORM_VACIO, dni: dniInicial || '' }));
  }, [open, dniInicial]);

  function continuar() {
    const { valido, errores: err } = validarCamposPaciente(form);
    setErrores(err);
    if (!valido) {
      setError('Revisá los campos marcados: son todos obligatorios.');
      return;
    }
    onSuccess({
      nombre: form.nombre.trim(),
      apellido: form.apellido.trim(),
      dni: form.dni.trim(),
      email: form.email.trim(),
      telefono: form.telefono.trim(),
      fecha_nacimiento: form.fecha_nacimiento,
      direccion: form.direccion.trim() || null,
      obra_social: form.obra_social || null,
      numero_afiliado: form.numero_afiliado.trim() || null,
    });
    setForm(FORM_VACIO);
    setError('');
    setErrores({});
  }

  function handleClose() {
    setError('');
    setErrores({});
    setForm(FORM_VACIO);
    onClose();
  }

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      title="Nuevo paciente"
      actions={
        <>
          <Button onClick={handleClose} sx={{ color: 'var(--c-acento)' }}>Cancelar</Button>
          <Button variant="contained" onClick={continuar} sx={btnPrimary}>
            Continuar con el turno
          </Button>
        </>
      }
    >
      {dniInicial && (
        <Box sx={{ mb: 2, p: 1.5, bgcolor: 'rgba(144,202,249,0.06)', borderRadius: 1, border: '1px solid rgba(144,202,249,0.2)' }}>
          <Typography sx={{ fontSize: 12, color: '#90a4ae' }}>
            DNI <strong style={{ color: '#e0e0e0' }}>{dniInicial}</strong> — no encontrado en el sistema.
            Los datos se guardarán junto con el turno.
          </Typography>
        </Box>
      )}

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <PacienteCamposForm form={form} setForm={setForm} obrasSociales={obrasSociales} autoFocusNombre errores={errores} />
    </DialogShell>
  );
}
